import React from "react";

function TablaJubilaciones() {
  return (
    <>
    <div className="tablaGrafica">
    <h5 class="tituloTabla">EN TIEMPO DE JUBILACIÓN</h5>
        <table>
        <thead>
          <tr>
            <th>Tipo Jubilación</th>
            <th>Total CURP Únicos</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>CESANTÍA EN EDAD AVANZADA</td>
            <td>22</td>
          </tr>
          <tr>
            <td>EDAD Y TIEMPO DE SERVICIO</td>
            <td>508</td>
          </tr>
          <tr>
            <td>JUBILACIÓN DIRECTA</td>
            <td>4759</td>
          </tr>
          <tr>
            <td>N/A</td>
            <td>48220</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>
              <strong>Total</strong>
            </td>
            <td>
              <strong>53509</strong>
            </td>
          </tr>
        </tfoot>
      </table>
   

    </div>


    </>
  );
}

export default TablaJubilaciones;
